import type {Component} from 'grapesjs';
import {addTagToMap} from '@Components/merge-tags/merge-tags-reducer';
import {unSelectedItemsForMultipleLists} from '@Components/list/list-reducer';
import {capitalizeFirstLetter} from '@Utils/string.util';

/** Formats a merge-tag option id into the `[[Key]]` or `[[Key::default]]` token inserted into the component HTML. `[[Key::default]]` tokens are persisted in saved templates, so the format is frozen. */
export function getMergeTagsFromOptionId(text: string, defaultValue: string | null = null): string {
  return `[[${capitalizeFirstLetter(text)}${defaultValue ? `::${defaultValue}` : ''}]]`;
}

/**
 * Appends a merge-tag token to the component's model (so it persists through save) and records the
 * tag in Redux, clearing the picker list's selection. Shared by every merge-tag picker that inserts
 * via the component model rather than a live RTE caret.
 */
export function appendMergeTagToComponent(component: Component, mergeTagKey: string, listId: string): void {
  component.append(getMergeTagsFromOptionId(mergeTagKey));
  window.PMW.redux.store.dispatch(addTagToMap({ccid: component.ccid, mergeTagKey}));
  window.PMW.redux.store.dispatch(unSelectedItemsForMultipleLists({listIds: [listId]}));
}
